import type {
	IMoodBoardImage,
	TMoodBoardScene,
} from 'api/resources/moodBoards';

// The board's background image fills the whole canvas, whatever the pan or
// zoom. It isn't part of the Excalidraw scene: it's drawn by a layer behind the
// canvas (see `MoodBoardBackground`), which only shows through while the
// canvas itself is transparent.

// The canvas colour while a background image shows through it.
export const TRANSPARENT_BACKGROUND = 'transparent';

// The stored background's URL, resolved from the board's uploads the same way
// scene images are (see `resolveSceneImages`). The stored URL is kept when the
// upload isn't among them (a board copied from a template). Null for a board
// with no background image.
export const resolveBackgroundUrl = (
	scene: TMoodBoardScene | null,
	images: IMoodBoardImage[],
): string | null => {
	const background = scene?.moodBoardBackground;

	if (!background) {
		return null;
	}

	const image = images.find((upload) => upload.fileId === background.fileId);

	return image?.original ?? background.url ?? null;
};

// The scene with its canvas made transparent, so a background image behind it
// shows through. The design manager already saves it that way while a
// background is set; this covers a scene saved with its colour still in place.
export const withTransparentCanvas = (
	scene: TMoodBoardScene | null,
): TMoodBoardScene | null =>
	scene && {
		...scene,
		appState: {
			...scene.appState,
			viewBackgroundColor: TRANSPARENT_BACKGROUND,
		},
	};
